module.exports = __webpack_public_path__ + "f09bc5ed5d3e3855cdbe581b97cf29e7.MP3";